var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useOkapiKy } from "@folio/stripes/core";
import { Pane, Button } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useQuery } from "react-query";
import { fetchPublisherPrefixById } from "../../api/publisherPrefixService";
import PublisherPrefixDetail from "./PublisherPrefixDetail";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { useDeclareLastUsedNumberAction } from "../../hooks/useDeclareLastUsedNumberAction";
import { useResetDeclarationAction } from "../../hooks/useResetDeclarationAction";
import { usePermissions } from "../../hooks/usePermissions";
import { buildPublisherPrefixActionMenu, } from "./publisherPrefixActionMenu";
var PublisherPrefixDetailPage = function () {
    var history = useHistory();
    var location = useLocation();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var canEditPublisherPrefix = usePermissions().canEditPublisherPrefix;
    var urlParams = new URLSearchParams(location.search);
    var publisherPrefixId = urlParams.get("id") || urlParams.get("detail");
    var _a = useQuery(["publisherPrefix", publisherPrefixId], function () { return fetchPublisherPrefixById(ky, publisherPrefixId); }, {
        enabled: !!publisherPrefixId,
    }), publisherPrefix = _a.data, isLoading = _a.isLoading, isError = _a.isError, error = _a.error;
    var _b = useDeclareLastUsedNumberAction(publisherPrefix), canShowDeclareAction = _b.canShowDeclareAction, declareAction = _b.declareAction;
    var _c = useResetDeclarationAction(publisherPrefix), canShowResetAction = _c.canShowResetAction, renderResetAction = _c.renderResetAction, resetModals = _c.resetModals;
    var extraActions = __spreadArray(__spreadArray([], (canShowDeclareAction ? [function () { return declareAction; }] : []), true), (canShowResetAction ? [renderResetAction] : []), true);
    var handleBackToList = function () {
        history.goBack();
    };
    if (!publisherPrefixId) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-agency.publisher-prefix.detail.pane.title",
                }) },
                React.createElement("p", null, formatMessage({
                    id: "ui-br-agency.publisher-prefix.id.not.provided",
                })),
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBackToList },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })))));
    }
    if (isLoading) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-agency.publisher-prefix.detail.pane.title",
                }) },
                React.createElement(FormattedMessage, { id: "ui-br-agency.loading" }))));
    }
    if (isError || !publisherPrefix) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-agency.publisher-prefix.detail.pane.title",
                }) },
                React.createElement("p", null, (error === null || error === void 0 ? void 0 : error.message) ||
                    formatMessage({
                        id: "ui-br-agency.publisher-prefix.not.found",
                    })),
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBackToList },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })))));
    }
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({ id: "ui-br-agency.publisher-prefix.detail.pane.title.named" }, { value: publisherPrefix.value }), firstMenu: React.createElement(Button, { buttonStyle: "default", onClick: handleBackToList, marginBottom0: true },
                React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })), actionMenu: buildPublisherPrefixActionMenu(publisherPrefix, canEditPublisherPrefix, function () {
                return history.push("/bragency/publisher-prefixes/edit/".concat(publisherPrefix.id));
            }, extraActions) },
            React.createElement(PublisherPrefixDetail, { publisherPrefix: publisherPrefix }),
            resetModals)));
};
export default PublisherPrefixDetailPage;
